import { FlatInfoComponent } from '@components/shared/flat-info/flat-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { format } from 'date-fns';
import { BadgeModule } from 'primeng/badge';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { EmptyStateComponent } from '../../../../../shared/empty-state/empty-state.component';
import { ArrivalRow } from '../../models/arrival-departure.model';

@Component({
  selector: 'app-arrivals-table',
  standalone: true,
  imports: [CommonModule, TableModule, BadgeModule, TranslateModule, FlatInfoComponent, EmptyStateComponent],
  template: `
    @if (arrivals && arrivals.length > 0) {
      <p-table
        [value]="arrivals"
        [tableStyle]="{ 'min-width': '50rem' }"
        [stripedRows]="true"
        styleClass="p-datatable-sm"
        responsiveLayout="scroll"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="vertical-align: middle">{{ 'arrivalDeparture.flat' | translate }}</th>
            <th style="vertical-align: middle">{{ 'arrivalDeparture.checkInDate' | translate }}</th>
            <th style="vertical-align: middle">{{ 'arrivalDeparture.checkOutDate' | translate }}</th>
            <th style="vertical-align: middle">{{ 'arrivalDeparture.hasCheckedIn' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-arrival
        >
          <tr>
            <td>
              <app-flat-info [flatInfo]="arrival.flatInfo"></app-flat-info>
            </td>
            <td>{{ formatDate(arrival.checkInDate) }}</td>
            <td>{{ formatDate(arrival.checkOutDate) }}</td>
            <td>
              <i
                *ngIf="arrival.hasCheckedIn"
                class="pi pi-check text-lg text-green-500"
              ></i>
              <span *ngIf="arrival.checkInTime">{{ arrival.checkInTime }}</span>
              <span
                *ngIf="!arrival.hasCheckedIn"
                class="text-gray-500"
                >—</span
              >
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4"><app-empty-state [title]="'arrivalDeparture.noArrivals'"></app-empty-state></td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <app-empty-state [title]="'arrivalDeparture.noArrivals'"></app-empty-state>
    }
  `
})
export class ArrivalsTableComponent {
  @Input() arrivals: ArrivalRow[] = [];

  constructor() {}

  /**
   * Format date to display in table
   */
  formatDate(date: Date): string {
    return format(date, 'yyyy-MM-dd');
  }
}
